import { http } from 'services/http';
import type { CreateUserReq, UserRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { USERS_ALL } from '../query-keys.ts';

export const useCreateUser = () => {
  return useMutationBase<UserRes, unknown, CreateUserReq>({
    mutationFn: async (variables) => {
      const res = await http.post<UserRes>('/v1/users', variables);

      return res.data;
    },
    invalidateCallback: () => [[USERS_ALL]],
  });
};
